// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"712a4428","340":"07ec5f3c","553":"1b6fdc19","556":"e0e2a60e","599":"ba2fe360","614":"c541f59c","652":"b6067660","745":"d41a494c","749":"3d2395e9","773":"16959046","787":"dea01d35","856":"2ef5496c","951":"12e47531"}[chunkId] + ".chunk.js";
};